<template lang="pug">
  v-menu(v-model="show", left, bottom)
    template(v-slot:activator="{ attrs, on }")
      v-btn(icon, v-bind="attrs", v-on="on")
        v-icon mdi-download

    v-list(dense, width=256).py-0
      v-list-item
        v-list-item-content
          v-list-item-title Download status
      
      Divider

      template(v-for="job, i in download.jobs")
        Divider(v-if="i", inset=56)

        v-list-item
          v-list-item-icon.mr-4.my-auto
            v-icon(v-if="job.status <= 1") mdi-download
            v-icon(v-else-if="job.status == 2") mdi-zip-box
            v-icon(v-else) mdi-check
          v-list-item-content
            v-list-item-title {{job.name}}
            v-list-item-subtitle
              span(v-if="job.status <= 1") Downloading {{job.count}} / {{job.total}}
              span(v-else-if="job.status == 2") Zipping {{(job.progress * 100).toFixed(0)}}%
              span(v-else) Finished
            v-progress-linear(v-if="job.status <= 1", :value="job.progress * 100", color="primary", :key="`download-${i}`")
            v-progress-linear(v-else-if="job.status == 2", :value="job.progress * 100", color="secondary", background-color="primary", :key="`zip-${i}`")

      v-list-item(v-if="download.jobs.length == 0")
        v-list-item-content
          v-list-item-subtitle No download jobs. To start download, <br> <b>Right click</b> or <b>press and hold</b> on items.
</template>

<script>
import download from '@/download';
import Divider from '@/components/Divider';

export default {
  name: 'DownloadStatus',

  components: { Divider },

  data() {
    return {
      download,
      show: false,
    };
  },

  watch: {
    'download.jobs.length'() {
      this.$nextTick(() => {
        this.show = true;
      });
    }
  }
};
</script>